import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {repoAppBuilder} from '@github-ui/repo-app-builder'
import type {AutomationHistoryPayload} from '../types/automation-revisions-payload'
import type {
  AutomationDetailPayload,
  AutomationsPayload,
  EditAutomationPayload,
  NewAutomationPayload,
} from '../types/automations-payload'

/**
 * Automations list page route configuration.
 */
export function buildAutomationsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('automationsRoute', {
    path: '/:owner/:repo/agents/automations',
    queries: [mainQuery<AutomationsPayload>()],
  })
}

export const automationsRoute = buildAutomationsRoute(repoAppBuilder)

/**
 * New automation page route configuration.
 */
export function buildNewAutomationRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('newAutomationRoute', {
    path: '/:owner/:repo/agents/automations/new',
    queries: [mainQuery<NewAutomationPayload>()],
  })
}

export const newAutomationRoute = buildNewAutomationRoute(repoAppBuilder)

/**
 * Individual automation detail page route configuration.
 */
export function buildAutomationDetailRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('automationDetailRoute', {
    path: '/:owner/:repo/agents/automations/:automationID',
    queries: [mainQuery<AutomationDetailPayload>()],
  })
}

export const automationDetailRoute = buildAutomationDetailRoute(repoAppBuilder)

export function buildAutomationHistoryRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('automationHistoryRoute', {
    path: '/:owner/:repo/agents/automations/:automationID/history',
    queries: [mainQuery<AutomationHistoryPayload>()],
  })
}

export const automationHistoryRoute = buildAutomationHistoryRoute(repoAppBuilder)

/**
 * Edit automation page route configuration.
 */
export function buildEditAutomationRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('editAutomationRoute', {
    path: '/:owner/:repo/agents/automations/:automationID/edit',
    queries: [mainQuery<EditAutomationPayload>()],
  })
}

export const editAutomationRoute = buildEditAutomationRoute(repoAppBuilder)
